import requests from "./httpService";

const PosterServices = {
    getPosterList: async () => {
        return requests.get(`/banner`);
    },
    // 🔹 Create Banner (FormData use hoga ⚠️)
    createPoster: async (body) => {
        return requests.post(`/banner`, body);
    },

    // 🔹 Get Banner By ID
    getPosterById: async (id) => {
        return requests.get(`/banner/${id}`);
    },

    // 🔹 Update Banner (FormData use hoga ⚠️)
    updatePoster: async (id, body) => {
        return requests.patch(`/banner/${id}`, body);
    },

    // 🔹 Delete Banner
    deletePoster: async (id) => {
        return requests.delete(`/banner/${id}`);
    }

};

export default PosterServices;